"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const MetricChartItem_vue_1 = __importDefault(require("./MetricChartItem.vue"));
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let CategoryStatus = class CategoryStatus extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filteredMetrics = [];
        this.showMetricsIndividualCategory = [];
        this.eventTracker = new EventTracker_1.default();
        this.isCollapsed = true;
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    resetDisplay() {
        this.showMetricsIndividualCategory = [];
    }
    get ordershownMetrics() {
        return this.shownMetrics.sort((a, b) => {
            if ('category' in a && 'category' in b) {
                if (a.category < b.category)
                    return -1;
                if (a.category > b.category)
                    return 1;
            }
            else if ('visual' in a && 'visual' in b) {
                if (a.visual < b.visual)
                    return -1;
                if (a.visual > b.visual)
                    return 1;
            }
            else if ('baseMetric' in a && 'baseMetric' in b) {
                if (a.baseMetric.name < b.baseMetric.name)
                    return -1;
                if (a.baseMetric.name > b.baseMetric.name)
                    return 1;
            }
            return 0;
        });
    }
    get shownMetrics() {
        return this.statusCategory.metrics;
    }
    get numberOfMetricsShown() {
        return this.statusCategory.metrics.length;
    }
    toggleMetrics(category) {
        const index = this.showMetricsIndividualCategory.indexOf(category);
        if (index === -1) {
            this.showMetricsIndividualCategory.push(category);
        }
        else {
            this.showMetricsIndividualCategory.splice(index, 1);
        }
    }
    addMetrics(category) {
        const index = this.showMetricsIndividualCategory.indexOf(category);
        if (index === -1) {
            this.showMetricsIndividualCategory.push(category);
        }
    }
    isShowingMetrics(category) {
        if (this.mode === 'single') {
            if (this.dimension === 'bio') {
                if (this.showMetricsIndividualCategory.includes(category))
                    return true;
                else
                    return false;
            }
            else
                return true;
        }
        else
            return true;
    }
    isMetricActive(m) {
        if (this.mode === 'single') {
            if ('code_name' in this.metric && 'code_name' in m) {
                if (this.dimension === 'bio') {
                    return m.code_name === this.metric.code_name;
                }
                if (this.dimension === 'phch') {
                    if ('test_name' in m && 'test_name' in this.metric) {
                        return (m.code_name === this.metric.code_name && m.test_name === this.metric.test_name);
                    }
                }
            }
        }
        else {
            if ('baseMetric' in this.metric && 'baseMetric' in m) {
                if (this.dimension === 'bio') {
                    return m.baseMetric.code_name === this.metric.baseMetric.code_name;
                }
                if (this.dimension === 'phch') {
                    if ('test_name' in m.baseMetric && 'test_name' in this.metric.baseMetric) {
                        return (m.baseMetric.code_name === this.metric.baseMetric.code_name && m.baseMetric.test_name === this.metric.baseMetric.test_name);
                    }
                }
            }
        }
    }
    toggleCategory() {
        this.isCollapsed = !this.isCollapsed;
        this.eventTrackerListener('toggleMetricCategory', {
            category: this.statusCategory.label,
            collapsed: this.isCollapsed
        });
    }
    eventTrackerListener(eventName, data) {
        this.eventTracker.trackEvent(eventName, data);
    }
    updateMetric(m) {
        this.$emit('updateMetric', m);
        const metric = m;
        const metricData = {
            name: metric.name,
            code_name: metric.code_name,
            type_code: metric.type_code,
            score: metric.score,
            rank: metric.rank
        };
        this.eventTrackerListener('selectMetric', metricData);
    }
    onSearchInputChange() {
        this.isCategoryCollapsed();
    }
    onUpdatedMetric() {
        this.isCategoryCollapsed();
    }
    isCategoryCollapsed() {
        // First for the Big Categories
        let tempFilteredMetrics = [];
        let phch = null;
        if ('baseMetric' in this.metric) {
            // vs
            if ('category' in this.metric.baseMetric) {
                // bio
                const allVSBioMetrics = this.statusCategory.metrics.filter((metric) => 'baseMetric' in metric && 'category' in metric.baseMetric);
                tempFilteredMetrics = [...allVSBioMetrics];
                if (this.searchInputContent.length === 0) {
                    //
                }
                else {
                    tempFilteredMetrics = tempFilteredMetrics.filter((fm) => fm.baseMetric.name
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, "")
                        .includes(this.searchInputContent.toLowerCase()) ||
                        fm.baseMetric.code_name
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, "")
                            .includes(this.searchInputContent.toLowerCase()));
                }
                if (this.searchInputContent.length > 0) {
                    if (tempFilteredMetrics.length === 1) {
                        this.updateMetric(tempFilteredMetrics[0]);
                    }
                }
            }
            else {
                if ('test_name' in this.metric.baseMetric) {
                    // phch
                    const allVSPhChMetrics = this.statusCategory.metrics.filter((metric) => 'baseMetric' in metric && 'test_name' in metric.baseMetric);
                    tempFilteredMetrics = [...allVSPhChMetrics];
                    if (this.searchInputContent.length === 0) {
                        //
                    }
                    else {
                        tempFilteredMetrics = tempFilteredMetrics.filter((fm) => fm.baseMetric.name
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, "")
                            .includes(this.searchInputContent.toLowerCase()));
                    }
                    if (this.searchInputContent.length > 0) {
                        if (tempFilteredMetrics.length === 1) {
                            this.updateMetric(tempFilteredMetrics[0]);
                        }
                    }
                }
            }
        }
        else {
            // single
            if ('category_map' in this.metric) {
                let categoryMap = null;
                const element = this.mainProjectDelivery.categorizedMetrics.find((metric) => metric.code_name === this.bioMetric.code_name);
                if (this.statusCategory.hook === 'prob' && 'in_top_to_improve' in element) {
                    categoryMap = element.in_top_to_improve.category_metric_slug || null;
                }
                else if (this.statusCategory.hook === 'benef' && 'in_categories' in element) {
                    categoryMap = element.in_categories.category_metric_slug || null;
                }
                // bio
                const allBioMetrics = this.statusCategory.metrics.filter((metric) => 'category_map' in metric);
                tempFilteredMetrics = [...allBioMetrics];
                // const categories = [...new Set(tempFilteredMetrics.map((m:BioMetric) => m.category_metric))];
                const metricName = 'name' in this.metric ? this.metric.name : '';
                const hasMetric = tempFilteredMetrics.findIndex((m) => m.name === metricName) !== -1;
                this.resetDisplay();
                if (this.collapseAll)
                    this.isCollapsed = true;
                else if (hasMetric)
                    this.isCollapsed = false;
                if (this.searchInputContent.length === 0) {
                    // const hasMetric = tempFilteredMetrics.findIndex((m:BioMetric) => m.name === this.metric.name) !== -1
                    // if(hasMetric) {
                    //     this.isCollapsed = false
                    // } else {
                    //     this.isCollapsed = true
                    // }
                }
                else {
                    tempFilteredMetrics.some((fm) => fm.name
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .includes(this.searchInputContent.toLowerCase()) ||
                        fm.code_name
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .includes(this.searchInputContent.toLowerCase()))
                        ? this.isCollapsed = false
                        : this.isCollapsed = true;
                }
                // Second for the small categories
                if (this.searchInputContent.length === 0) {
                    this.addMetrics(categoryMap);
                }
                else {
                    tempFilteredMetrics = tempFilteredMetrics.filter((fm) => fm.name
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .includes(this.searchInputContent.toLowerCase()) ||
                        fm.code_name
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .includes(this.searchInputContent.toLowerCase()));
                    tempFilteredMetrics.forEach((m) => {
                        this.addMetrics(this.bioMetric.category_map.slug);
                    });
                }
                if (this.searchInputContent.length > 0) {
                    if (tempFilteredMetrics.length === 1) {
                        this.updateMetric(tempFilteredMetrics[0]);
                    }
                    tempFilteredMetrics.forEach((m) => {
                        this.addMetrics(categoryMap);
                    });
                }
            }
            else {
                // phch
                const allPhChMetrics = this.statusCategory.metrics.filter((metric) => metric.dimension === 'phch');
                tempFilteredMetrics = [...allPhChMetrics];
                const metricName = 'name' in this.metric ? this.bioMetric.name : '';
                const hasMetric = tempFilteredMetrics.findIndex((m) => m.name === metricName) !== -1;
                if (this.collapseAll)
                    this.isCollapsed = true;
                else if (hasMetric)
                    this.isCollapsed = false;
                if (this.searchInputContent.length === 0) {
                    //const hasMetric = tempFilteredMetrics.findIndex((m:BioMetric) => m.name === this.metric.name) !== -1
                    // if(hasMetric) {
                    //     this.isCollapsed = false
                    // } else {
                    //     this.isCollapsed = true
                    // }
                }
                else {
                    tempFilteredMetrics = tempFilteredMetrics.filter((fm) => fm.name
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .includes(this.searchInputContent.toLowerCase()) ||
                        fm.test_name
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .includes(this.searchInputContent.toLowerCase()));
                }
                if (this.searchInputContent.length > 0) {
                    if (tempFilteredMetrics.length === 1) {
                        this.updateMetric(tempFilteredMetrics[0]);
                    }
                }
            }
        }
        this.filteredMetrics = tempFilteredMetrics;
    }
    forcedCollapse() {
        if (this.collapseAll) {
            this.isCollapsed = true;
            this.$emit('afterForcedCollapse');
        }
    }
    isFirstInCategory(m) {
        if ('baseMetric' in m) {
            // Vs
            return false;
        }
        else {
            // Single
            if ('category_map' in m) {
                // Bio
                const allMetricsInCategory = this.filteredMetrics.filter((fm) => fm.category_map.slug === m.category_map.slug);
                const ix = allMetricsInCategory.findIndex((fm) => fm.code_name === m.code_name);
                return ix === 0;
            }
            else {
                // PhCh
                return false;
            }
        }
    }
    get bioMetric() {
        return this.metric;
    }
    mounted() {
        // Es VS
        if (this.statusCategory.isBeCropComparisonMetric) {
            // this.isCollapsed
        }
        else {
            if (this.statusCategory.isBioMetric) {
                // is bio
                if ('category' in this.metric) {
                    if (this.metric.isBeneficial && this.statusCategory.hook === 'benef') {
                        this.isCollapsed = false;
                    }
                    if (!this.metric.isBeneficial && this.statusCategory.hook === 'prob') {
                        this.isCollapsed = false;
                    }
                }
            }
            else {
                // is phch
            }
        }
        if (this.statusCategory.isBeCropComparisonMetric) {
            const allVSMetrics = this.statusCategory.metrics.filter((metric) => 'baseMetric' in metric);
            this.filteredMetrics = [...allVSMetrics];
        }
        else {
            if (this.statusCategory.isBioMetric) {
                const allBioMetrics = this.statusCategory.metrics.filter((metric) => 'category' in metric);
                this.filteredMetrics = [...allBioMetrics];
            }
            else {
                const allPhChMetrics = this.statusCategory.metrics.filter((metric) => 'visual' in metric);
                this.filteredMetrics = [...allPhChMetrics];
            }
        }
        this.isCategoryCollapsed();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.BeCropMetricsBlock({}) })
], CategoryStatus.prototype, "statusCategory", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], CategoryStatus.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], CategoryStatus.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], CategoryStatus.prototype, "collapseAll", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], CategoryStatus.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CategoryStatus.prototype, "searchInputContent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], CategoryStatus.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CategoryStatus.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CategoryStatus.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CategoryStatus.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('searchInputContent')
], CategoryStatus.prototype, "onSearchInputChange", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('metric')
], CategoryStatus.prototype, "onUpdatedMetric", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('collapseAll')
], CategoryStatus.prototype, "forcedCollapse", null);
CategoryStatus = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ChevronDown: lucide_vue_next_1.ChevronDown,
            ChevronUp: lucide_vue_next_1.ChevronUp,
            ChevronRight: lucide_vue_next_1.ChevronRight,
            MetricChartItem: MetricChartItem_vue_1.default
        },
    })
], CategoryStatus);
exports.default = CategoryStatus;
